import React, { useState } from "react";
import NavLink from "components/NavLink";
import Link from "components/Link";
import TooltipsApp from "./TooltipsApp";
import Dropdown from "react-bootstrap/Dropdown";
import { colorsPallette, getStorage } from "pages/Utils";
// import { colorsPallette, getStorage } from "pages/Utils";

export const iconNotif = {
  15: "undo",
  16: "undo",
  17: "undo",
  5: "done",
  10: "done",
};

const BtnIcon = (props) => {
  const [trigger, settrigger] = useState(0);
  const [dropdown, setdropdown] = useState(false);
  const Links = (props) => <TooltipsApp {...props} />;
  // const { id_application } = JSON.parse(getStorage("user_login"));
  const userLogin = JSON.parse(getStorage("user_login")) || {};
  const { id_application } = userLogin;
  const [openGroupIdx, setOpenGroupIdx] = useState(null);

  const handleTrigger = () => {
    settrigger((trigger) => trigger + 1);
    setdropdown(false);
  };

  // if (props.dropdown) {
  //     return (
  //         <div className='container-dropdown-notif'>
  //             <Dropdown>
  //                 <Dropdown.Toggle variant="" id="dropdown-basic-2">
  //                     <div className='btn-icons relative'>
  //                         {props.notif ? (
  //                             <div className='item-count-notif'>{props.notif}</div>
  //                         ) : null}
  //                         <span className='material-icons'>{props.icon}</span>
  //                     </div>
  //                 </Dropdown.Toggle>

  //                 <Dropdown.Menu show={dropdown}>
  //                     <div className='dropdown-notif-body'>
  //                         {props.dropdown.data ? (
  //                             <>
  //                                 {props.dropdown.data.map((m, i) => {
  //                                     let icon = iconNotif[m.id_status_pengajuan] ? iconNotif[m.id_status_pengajuan] : 'flag'
  //                                     return (
  //                                         <Link key={i} href={m.url} onClick={() => props.onRead(m.id_msg)} className={`d-flex align-items-center ${m.is_read == 1 ? 'is-read' : ''}`}>
  //                                             <div className='me-3 ms-3'>
  //                                                 <span className='material-icons' style={{ color: icon == 'undo' ? colorsPallette.danger : icon == 'done' ? colorsPallette.success : colorsPallette.warning }}>
  //                                                     {icon}
  //                                                 </span>
  //                                             </div>
  //                                             <div className='flex-1'>
  //                                                 <div className='dropdown-notif-item-title'>{m.status_pengajuan}</div>
  //                                                 <div className='dropdown-notif-item-desc mb-1'>{m.msg}</div>
  //                                                 <p className='dropdown-notif-item-foot'>
  //                                                     <span className='material-icons'>schedule</span>
  //                                                     {m.created_at}
  //                                                     {/* <span>
  //                                             </span> */}
  //                                                     <span className='material-icons'>person</span>
  //                                                     {/* <span>
  //                                             </span> */}
  //                                                     {m.created_by_desc} ({m.nama_group})
  //                                                 </p>
  //                                             </div>
  //                                         </Link>
  //                                     )
  //                                 })}
  //                             </>
  //                         ) : null}
  //                     </div>

  //                     <Link onClick={handleTrigger} href={`/risk_task`} className='text-center dropdown-link-more'>
  //                         View All Task
  //                     </Link>
  //                 </Dropdown.Menu>

  //             </Dropdown>
  //         </div>
  //     )
  // }

  if (props.dropdown) {
    return (
      <div
        className="container-dropdown-notif"
        style={props.style ? props.style : null}
      >
        <Dropdown>
          <Dropdown.Toggle variant="" id="dropdown-basic-2">
            <div className="btn-icons relative">
              {props.notif ? (
                <div className="item-count-notif">{props.notif}</div>
              ) : null}
              <span className="material-icons">{props.icon}</span>
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {props.is_dropdown_aplikasi ? (
              props.data_aplikasi ? (
                <div className="menu-app-wrapper mx-2">
                  {Object.values(props.data_aplikasi).map(
                    (m, i) =>
                      m.id_application != id_application && (
                        <button
                          className="menu-app-item h-[100%]"
                          key={i}
                          onClick={
                            () =>
                              // console.log("i", m)
                              props.onClickGroup && props.onClickGroup(m)
                            // setOpenGroupIdx(openGroupIdx === i ? null : i)
                          }
                        >
                          <img
                            src={
                              // "https://images.glints.com/unsafe/glints-dashboard.oss-ap-southeast-1.aliyuncs.com/company-logo/486f789b3eb55c6225a310c3a7351e8f.jpg"
                              "/perisai.png"
                            }
                            alt=""
                            width="20px"
                          />
                          <small>{m.nama}</small>
                        </button>
                      )
                  )}
                </div>
              ) : (
                <div>Anda Belum Terdaftar Di Aplikasi Lain</div>
              )
            ) : (
              <div className="dropdown-notif-body">
                {props.dropdown.data ? (
                  <>
                    {props.dropdown.data.map((m, i) => {
                      let icon = iconNotif[m.id_status_pengajuan]
                        ? iconNotif[m.id_status_pengajuan]
                        : "arrow_forward";
                      const notifKey =
                        m.id_msg || m.id || m.url || `notif-item-${i}`;
                      return (
                        <Dropdown.Item
                          key={notifKey}
                          className={m.is_read == 1 ? "" : "notif-un-read"}
                        >
                          <Link
                            href={m.url}
                            onClick={() => props.onRead(m.id_msg)}
                            className={`d-flex align-items-center ${
                              m.is_read == 1 ? "is-read" : ""
                            }`}
                          >
                            <div className="me-3 ms-3">
                              <span
                                className="material-icons"
                                style={{
                                  color:
                                    icon == "undo"
                                      ? colorsPallette.danger
                                      : icon == "done"
                                      ? colorsPallette.success
                                      : colorsPallette.info,
                                }}
                              >
                                {icon}
                              </span>
                            </div>
                            <div className="flex-1">
                              <div
                                className="dropdown-notif-item-title"
                                style={{
                                  fontWeight:
                                    m.is_read == 1 ? "normal" : "bold",
                                }}
                              >
                                {m.status_pengajuan}
                              </div>
                              <div className="dropdown-notif-item-desc mb-1">
                                {m.msg}
                              </div>
                              <p className="dropdown-notif-item-foot">
                                <span className="material-icons">schedule</span>
                                {m.created_at}
                                <span className="material-icons">person</span>
                                {m.created_by_desc} ({m.nama_group})
                              </p>
                            </div>
                          </Link>
                        </Dropdown.Item>
                      );
                    })}
                  </>
                ) : null}
              </div>
            )}

            {!props.is_dropdown_aplikasi ? (
              <Dropdown.Item>
                <Link
                  onClick={handleTrigger}
                  href={`/risk_task`}
                  className="text-center dropdown-link-more"
                >
                  View All Task
                </Link>
              </Dropdown.Item>
            ) : null}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }

  if (props.href) {
    return (
      <NavLink href={props.href} active={false}>
        <div className="btn-icons relative">
          {props.notif ? (
            <div className="item-count-notif">{props.notif}</div>
          ) : null}
          <span className="material-icons">{props.icon}</span>
        </div>
      </NavLink>
    );
  }
  return (
    <div
      className="d-flex flex-direction-row justify-content-center align-items-center"
      style={props.style ? props.style : null}
    >
      <div
        className="btn-icons relative"
        onClick={props.onTap ? props.onTap : null}
      >
        {props.notif ? (
          <div className="item-count-notif">{props.notif}</div>
        ) : null}
        {props.tooltips ? (
          <Links title={props.tooltips} id={props.tooltips}>
            <span
              className="material-icons"
              style={{
                fontSize: props.size ? props.size : 24,
                color: props.color ? props.color : "#333",
              }}
            >
              {props.icon}
            </span>
          </Links>
        ) : (
          <span
            className="material-icons"
            style={{
              fontSize: props.size ? props.size : 24,
              color: props.color ? props.color : "#333",
            }}
          >
            {props.icon}
          </span>
        )}
      </div>
    </div>
  );
};

export default BtnIcon;
